import {Link} from 'react-router-dom';
function Footer() {
    const today = new Date();
    let year = today.getFullYear();
  return (
    <div className="container text-center">
      <div className="row text-center">
            <div className="mt-5 ">
              <a
                className="text-dark"  target={"_blank"}
                href="https://www.linkedin.com/company/vertoxlabs/"
              >
                <i class="mx-1 fa-brands fs-4 fa-linkedin"></i>
              </a>
              <a className="text-dark" target={"_blank"} href="#">
                <i class="mx-1 fa-brands fs-4 fa-square-facebook"></i>
              </a>
              <a className="text-dark" target={"_blank"} href="#">
                <i class="mx-1 fa-brands fs-4 fa-square-instagram"></i>
              </a>
              <a className="text-dark" target={"_blank"} href="https://twitter.com/VertoX_Labs">
                <i class="mx-1 fa-brands fs-4 fa-square-twitter"></i>
              </a>
            </div>
          </div>
      <p>Copyright &copy; {year} by <Link to='/'>www.vertoxlabs.com</Link> proudly designed by Team HYDRA</p>
    </div>
  );
}

export default Footer;
